<script lang="ts">
  // The one "Clear filters" control, next to FilterSelects / in filter sheets.
  //   {#if activeCount}<ClearFiltersButton count={activeCount} onclick={reset} />{/if}
  import { X } from '@lucide/svelte';
  import '../messages/ui';
  import { t } from '../i18n.svelte';

  interface Props {
    onclick: () => void;
    /** Number of active filters, shown after the label. */
    count?: number;
    label?: string;
    size?: 'sm' | 'md';
    disabled?: boolean;
  }
  let { onclick, count, label, size = 'sm', disabled = false }: Props = $props();
</script>

<button type="button" class="clear {size}" {disabled} {onclick}>
  <X aria-hidden="true" />
  <span>{label ?? t('ui.clear_filters')}</span>
  {#if count}<span class="n tabular">{count}</span>{/if}
</button>

<style>
  .clear {
    display: inline-flex;
    align-items: center;
    gap: var(--space-1);
    height: var(--control-h-sm);
    padding: 0 var(--space-2_5);
    border: 0;
    border-radius: var(--radius-pill);
    background: transparent;
    color: var(--text-2);
    font-size: var(--text-sm);
    font-weight: var(--weight-medium);
    white-space: nowrap;
    transition: background var(--dur), color var(--dur);
  }
  .md { height: var(--control-h); font-size: var(--text-base); }
  .clear :global(svg) { width: var(--icon-sm); height: var(--icon-sm); }
  .clear:hover:not(:disabled) { background: var(--surface-hover); color: var(--text); }
  .clear:focus-visible { outline: none; box-shadow: var(--ring); }
  .clear:disabled { opacity: 0.5; }
  .n {
    min-width: 18px;
    padding: 0 var(--space-1);
    border-radius: var(--radius-pill);
    background: var(--surface-3);
    font-size: var(--text-2xs);
    font-weight: var(--weight-semibold);
    line-height: 18px;
    text-align: center;
  }
</style>
